/*
---------------------------------
Module - card-carousel
---------------------------------
Note: This carousel will only render if there are 4 or more results in total
*/

import Glide from '@glidejs/glide'

import {Visible} from 'PlugAndPlay/_global/js/glideExtensions'

import {getCurrentScreenSizeInt} from 'PlugAndPlay/_global/js/screenSize'

import Handlebars from "handlebars/dist/handlebars";

import {hbsHelpers} from 'PlugAndPlay/_global/js/handlebarsHelpers'

import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import shuffle from 'lodash/shuffle';

(function ( ) {

    const cardCarousel = (function () {
        
        let elCardCarousel;
        let glideCardCarousel;

        const currentURL = window.location.href.split('?')[0]; // Current URL user is viewing. If user is viewing an event detail page, make sure cards displayed don't show the same event

        let maxSetting; 50 // 50 limit by default. Can be overriden with data-max attribute
        const minSetting = 4; // Used to ensure carousel is display minimum of 4 results to render the carousel

        // Store the ajaxed results data either from Matrix asset listing or Funnelback endpoint
        let resultsData = [];
        let backupResultsData = [];

        let displayResultsCount; // Keep track of how many results we are actually displaying (After slicing). If equal to minSetting, need to disable nav arrows and carousel at 1200px

        let isCarouselActive;

        // Disable the carousel if there are only 4 slides at 1200px breakpoint
        function processBreakpoint() {

            var currentScreenSizeInt = getCurrentScreenSizeInt();

            if (currentScreenSizeInt > 4) {

                glideCardCarousel.disable();
                // Hide peeking cards and navigation arrows
                elCardCarousel.classList.add("card-carousel--hide-overflow");
                
            } else {

                glideCardCarousel.enable();
                elCardCarousel.classList.remove("card-carousel--hide-overflow");

            }

        }

        function peekSlideClicked(event) {

            // Only do this if carousel is active
            // This is because on desktop, even if carousel is destroyed, the glide API methods are still active
            if (isCarouselActive) {

                const thisSlide = event.target.closest(".glide__slide");

                if (thisSlide && !thisSlide.classList.contains("glide__slide--visible")) {

                    // Don't go to link
                    event.preventDefault();

                    // This must be a peek slide
                    // Only if the clicked peek slide has a sibling and the sibling has the active class
                    if (thisSlide.nextElementSibling && thisSlide.nextElementSibling.classList.contains("glide__slide--active")) {

                        // This is before the active slide
                        // Scroll back once
                        glideCardCarousel.go('<');

                    } else {

                        // This is after the active slide
                        // Scroll forward once
                        glideCardCarousel.go('>')
                        
                    }

                }

            }

        }

        function initiateCarousel() {

            const settings = {

                // We're not using the peek settings. Relying on overflow: visible and fixed width so that when browser width expands, more overflow part of slide is shown
                type: "carousel",
                gap: 30,
                perView: 4,
                perTouch: 1,
                breakpoints: {
                    
                    1199: {
                        gap: 30,
                        perView: 3,
                        perTouch: 1,
                    },
                    991: {
                        gap: 30,
                        perView: 2,
                        perTouch: 1,
                    },
                    767: {
                        gap: 20,
                        perView: 2,
                        perTouch: 1
                    },
                    575: {
                        gap: 20,
                        perView: 1,
                        perTouch: 1
                    },
                    
                }
    
            };

            const mountSettings = {

                'Visible': Visible,

            }

            // Autoplay Setting
            if (elCardCarousel.hasAttribute("data-autoplay")) {
                settings.autoplay = 5000;
            }

            // Initiate the carousel
            glideCardCarousel = new Glide(elCardCarousel, settings).mount(mountSettings);

            elCardCarousel.addEventListener("click", peekSlideClicked);

            isCarouselActive = true;

            // If there only the minimum results, then disable the carousel at 1200px;
            // console.log((resultsData.length + backupResultsData.length));
            if (displayResultsCount === minSetting) {

                processBreakpoint();

                window.addEventListener('resize', debounce(processBreakpoint, 100));

            }
            
        }

        function processResultsData() {

            // Initiate handelbars helpers
            hbsHelpers();

            // Compile the handlebars template
            const compiledTemplate = Handlebars.compile(elCardCarousel.querySelector(".card-carousel__template").innerHTML);

            let processedResults = cloneDeep(resultsData);

            // Filter out objects which don't have a date property or date is blank and url is not the same as existing URL
            // No date property or date is blank - This can happen if there are events from Matrix asset listings (featured events) which have past
            // URL is not the same as existing URL - When viewing an event detail page, make sure "You may like" cards retrieved do not display the same event again
            // Note that this is very dependent of the data structure from funnelback JSON FTL (Free events carousel, you may like) and #154061 (Featured events caraousel)
            processedResults = processedResults.filter(obj => obj?.instancesData?.upcomingInstance?.date && obj.url !== currentURL);

            // Results are to be randomised if shuffle Setting is on
            if (elCardCarousel.hasAttribute("data-shuffle")) {
                processedResults = shuffle(processedResults);
            }

            let processedResultsLength = processedResults.length;

            if (processedResultsLength >= maxSetting) {

                // If there are more results than or equal to the max setting
                displayResultsCount = maxSetting;

                processedResults = processedResults.slice(0, maxSetting);
                
                // Compile the results and insert into the wrapper
                elCardCarousel.innerHTML = compiledTemplate(processedResults);

                // Initiate the carousel
                initiateCarousel();

            } else {

                // There were less results than the max setting
                // This can happen to the You may also like carousel where the initial results is less than 4
                // Need featured events (if any) to fill up the rest
                // console.log(`There were ${processedResultsLength} main results which is less than the max setting of ${maxSetting}`)
                
                // Check if data-backup-results endpoint defined
                const backupResultsEndpoint = elCardCarousel.getAttribute("data-backup-results");

                if (backupResultsEndpoint) {

                    // Call backup results endpoint to get more results to fill leftover
                    let xhr = new XMLHttpRequest();

                    xhr.open("GET", backupResultsEndpoint, true);

                    xhr.onload = function() {

                        // Get backup results which would hopefully fill up the leftover
                        backupResultsData = JSON.parse(xhr.response);

                        if (backupResultsData.length) {

                            let processedBackupResults = cloneDeep(backupResultsData);

                            // Filter out objects which don't have upcoming date url is not the same as existing URL
                            // No date property or date is blank - This can happen if there are events from Matrix asset listings (featured events) which have past
                            // URL is not the same as existing URL - When viewing an event detail page, make sure cards retrieved do not display the same event
                            processedBackupResults = processedBackupResults.filter(obj => obj?.instancesData?.upcomingInstance.date && obj.url !== currentURL);

                            // Remove dupes from backup results that exist in original result already
                            processedBackupResults = processedBackupResults.filter(processedBackupResult => {

                                // If a dupe title is found, exclude
                                if (!processedResults.some(processedResult => processedResult.title === processedBackupResult.title)) {
                                    return true;
                                }

                            });

                            // Shuffle Setting - Backup results are to be randomised
                            if (elCardCarousel.hasAttribute("data-shuffle")) {
                                processedBackupResults = shuffle(processedBackupResults);
                            }

                            const remainingToFill = maxSetting - processedResults.length

                            // console.log(`Need to fill ${remainingToFill} slots`);

                            processedBackupResults = processedBackupResults.slice(0, remainingToFill);

                            const combinedResults = processedResults.concat(processedBackupResults);

                            if (combinedResults.length >= minSetting) {

                                // console.log("Now there's enough combined total results");

                                displayResultsCount = combinedResults.length;

                                // Compile the results and insert into the wrapper
                                elCardCarousel.innerHTML = compiledTemplate(combinedResults);
                                
                                // Initiate the carousel
                                initiateCarousel();

                            }

                            
                        } else if (processedResultsLength >= minSetting) {

                            // There were no results from the backup results end point 
                            // But since there are more than 3 results (minSetting), render the carousel
                            // console.log("No backup results");
                            // console.log(`But since there are ${processedResultsLength} main results, render the carousel`)
    
                            displayResultsCount = processedResultsLength;

                            // Compile the results and insert into the wrapper
                            elCardCarousel.innerHTML = compiledTemplate(processedResults);
                            
                            // Initiate the carousel
                            initiateCarousel();
    
                        }
                    
                    }

                    xhr.send();

                } else if (processedResultsLength >= minSetting) {

                    // No backup results endpoint defined to fill leftover 
                    // But since there are more than 3 results (minSetting), render the carousel
                    // console.log("No backup results endpoint");
                    // console.log(`But since there are ${processedResultsLength} main results, render the carousel`)

                    displayResultsCount = processedResultsLength;

                    // Compile the results and insert into the wrapper
                    elCardCarousel.innerHTML = compiledTemplate(processedResults);
                    
                    // Initiate the carousel
                    initiateCarousel();

                }
                
            }

        }

        function getResultsData() {

            let resultsEndpoint = elCardCarousel.getAttribute("data-results");

            let xhr = new XMLHttpRequest();

            xhr.open("GET", resultsEndpoint, true);

            xhr.onload = function() {

                resultsData = JSON.parse(xhr.response);

                if (resultsData.length) {
                    processResultsData();
                }

            }

            xhr.send();

        }

        function init(element) {

            try {

                elCardCarousel = element;

                // Override max setting
                if (elCardCarousel.getAttribute("data-max")) {
                    // Convert to Number because need to do strict comparision later with integers
                    maxSetting = Number(elCardCarousel.getAttribute("data-max"));
                }

                // Ajax search results JSON data
                getResultsData();

            } catch (error) {
                console.error(error);
            }

        }

        return {
            init: init
        };

    });

    document.addEventListener("DOMContentLoaded", function () {

        let elCardCarousels = document.querySelectorAll(".card-carousel");

        if (elCardCarousels) {
            
            elCardCarousels.forEach((element) => {
                
                // Instantiate the object instance
                let cardCarouselInstance = cardCarousel();

                cardCarouselInstance.init(element);

            });

        }

    });

})();
